module.exports = __webpack_public_path__ + "static/media/embassy-landing.f5b4f700.png";